import React, { useEffect, useState } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { getTokenClientes } from '../Store/storages/AuthenticationStorage';
import LoadingApp from '../components/LoadingApp';
import { PrivateRouteProps } from '../interfaces/props/PrivateRouteProps';
import Page from '../layout/Page';
import SegundaViaBoleto from '../pages/Financeiro/SegundaViaBoleto';
import ComprovanteRecebidos from '../pages/Financeiro/ComprovanteRecebidos';
import DemonstrativoFatura from '../pages/Financeiro/DemonstrativoFatura';
import ExtratoCoparticipacao from '../pages/Financeiro/ExtratoCoparticipacao';
import MinhasGuias from '../pages/GuiasEAutorizacoes/MinhasGuias';
import Home from '../pages/Home';
import Login from '../pages/Login';
import Register from '../pages/Login/Register';
import MeuCadastro from '../pages/MeuPlano/MeuCadastro';
import Notification from '../pages/Notification';
import Notifications from '../pages/Notifications';
import AgendarConsulta from '../pages/SaudeOnline/AgendarConsulta';
import AtestadoMedicoDigital from '../pages/SaudeOnline/AtestadoMedicoDigital';
import BiometriaFacial from '../pages/SaudeOnline/BiometriaFacial';
import IngressarNoAtendimento from '../pages/SaudeOnline/IngressarNoAtendimento';
import MeusAgendamentos from '../pages/SaudeOnline/MeusAgendamentos';
import PAVirtual from '../pages/SaudeOnline/PAVirtual';
import AtivacaoDeGuia from '../pages/GuiasEAutorizacoes/AtivaçãoDeGuia';
import RevalidacaoDeGuia from '../pages/GuiasEAutorizacoes/RevalidaçãoDeGuia';
import ResultadoExames from '../pages/SaudeOnline/ResultadoExames';
import TeleorientacaoSaude from '../pages/SaudeOnline/TeleorientacaoSaude';
import CadastrarBoleto from '../pages/Financeiro/CadastroBoleto';
import LinhaTempo from '../pages/SaudeOnline/LinhaTempo';
import CadastroEmailNFe from '../pages/Financeiro/CadastroEmailNFe';
import AlterarSenha from '../pages/MeuPlano/AlterarSenha';
import DescontoEmFarmacia from '../pages/MeusBeneficios/DescontoEmFarmacia';
import UtilizacaoDosServicos from '../pages/MeuPlano/InformacoesDoPlano/UtilizacaoDosServicos';
import PermissoesVisualizacao from '../pages/MeuPlano/PermissoesVisualizacao';
import CancelamentoHistorico from '../pages/MeuPlano/Cancelamento/Historico';
import SimuladorMensalidadeReajuste from '../pages/Financeiro/SimuladorMensalidadeReajuste';
import CartaDebitoAutomatico from '../pages/Financeiro/CartaDebitoAutomatico';
import DeclaracaoPermanencia from '../pages/InformacoesContratuais/DeclaracaoPermanencia';
import ComponenteCadastral from '../pages/MeuPlano/InformacoesDoPlano/ComponenteCadastral';
import ConsultarCoberturas from '../pages/InformacoesContratuais/ConsultarCoberturas';
import GuiaMedico from '../pages/GuiaMedico';
import PesquisaSatisfacao from '../pages/Notifications/PesquisaSatisfacao';
import FaleComUnimed from '../pages/FaleComUnimed';
import SeguroViagemInternacional from '../pages/MeusBeneficios/SeguroViagemInternacional';
import GuiaMedicoBusca from '../pages/GuiaMedico/BuscaServicos';
import SolicitacaoCancelamento from '../pages/MeuPlano/Cancelamento/SolicitacaoCancelamento';
import SolicitacaoDeReembolso from '../pages/Financeiro/Reembolso/SolicitacaoDeReembolso';
import ValorReembolso from '../pages/Financeiro/Reembolso/ValorReembolso';
import RegrasReembolso from '../pages/Financeiro/Reembolso/RegrasReembolso';
import ReembolsoFAQ from '../pages/Financeiro/Reembolso/PerguntasFrequentes';
import PedidoReembolsoDetalhe from '../pages/Financeiro/Reembolso/MeusReembolsos/PedidoReembolsoDetalhe';
import MeusReembolsos from '../pages/Financeiro/Reembolso/MeusReembolsos';
import ExcluirConta from '../pages/MeuPlano/ExcluirConta';
import ReceitaDigital from '../pages/SaudeOnline/ReceitaDigital';
import Anexos from '../pages/SaudeOnline/Anexos';
import PalestrasEventos from '../pages/SaudeBemEstar/PalestrasEventos';
import PalestrasEventosConfirmados from '../pages/SaudeBemEstar/PalestrasEventos/Confirmados';
import PalestrasEventosConvites from '../pages/SaudeBemEstar/PalestrasEventos/Convites';
import Conteudos from '../pages/SaudeBemEstar/Conteudos';
import Conteudo from '../pages/SaudeBemEstar/Conteudos/Conteudo';
import AutoAvaliacao from '../pages/SaudeBemEstar/AutoAvaliacao';
import AutoAvaliacaoQuestoes from '../pages/SaudeBemEstar/AutoAvaliacao/AutoAvaliacaoQuestoes';
import AutoAvaliacaoResult from '../pages/SaudeBemEstar/AutoAvaliacao/AutoAvaliacaoResult';
import UnimedAcolhe from '../pages/SaudeBemEstar/UnimedAcolhe';
import ManualUnimedAcolhe from '../pages/SaudeBemEstar/UnimedAcolhe/ManualUnimedAcolhe';
import OQueEUnimedAcolhe from '../pages/SaudeBemEstar/UnimedAcolhe/OQueEUnimedAcolhe';
import MeuPsicoterapeuta from '../pages/SaudeBemEstar/MeuPsicoterapeuta';
import SolicitarTrocaPsicoterapeuta from '../pages/SaudeBemEstar/MeuPsicoterapeuta/SolicitarTroca';
import MeuDiario from '../pages/SaudeBemEstar/MeuDiario';
import Agendamentos from '../pages/SaudeBemEstar/Agendamentos';
import AgendamentosMaisDetalhes from '../pages/SaudeBemEstar/Agendamentos/AgendamentosMaisDetalhes';
import Agendar from '../pages/SaudeBemEstar/Agendamentos/AgendarConsulta/Agendar';
import MeusAgendamentosPsico from '../pages/SaudeBemEstar/Agendamentos/MeusAgendamentos/MeusAgendamentosPsico';
import DiaryRegister from '../pages/SaudeBemEstar/MeuDiario/DiaryRegister';
import { Captacao } from '../pages/GestaoDeCronicos/Captacao';
import Conversas from '../pages/GestaoDeCronicos/ChatComEquipeGC/Conversas';
import NovaConversa from '../pages/GestaoDeCronicos/ChatComEquipeGC/Conversas/NovaConversa';
import Encerramento from '../pages/GestaoDeCronicos/Encerramento';
import { PrimeiroAgendamentoWrapper } from '../pages/GestaoDeCronicos/PrimeiroAgendamento';
import HomeGC from '../pages/GestaoDeCronicos/HomeGC';
import ConhecaOPrograma from '../pages/GestaoDeCronicos/ConhecaOPrograma';
import ManualDoUsuarioCronicos from '../pages/GestaoDeCronicos/ManualDoUsuarioCronicos';
import MapaDoSite from '../pages/MapaDoSite';

import AgendamentosGC from '../pages/GestaoDeCronicos/AgendamentosGC';
import AutoavaliacaoInfo from '../pages/SaudeBemEstar/AutoAvaliacao/AutoAvaliacaoInfo';
import AgendarGC from '../pages/GestaoDeCronicos/AgendarGC';
import ManualUsoPlano from '../pages/MeuPlano/ManualUsoPlano';
import ClassificacaoProcedimentos from '../pages/InformacoesContratuais/ClassificacaoProcedimentos';
import ReanaliseDeNegativa from '../pages/GuiasEAutorizacoes/ReanaliseDeNegativa';
import NotificationConfirmarConsulta from '../pages/Notification/NotificationConfirmarConsulta';
import CartaoVirtual from '../pages/SaudeOnline/CartaoVirtual';
import NotificationMedicinaPreventiva from '../pages/Notification/NotificationMedicinaPreventiva';
import AvaliacaoEspacoPersonal from '../pages/SaudeOnline/AvaliacaoEspacoPersonal';
import ChatComEquipeGC from '../pages/GestaoDeCronicos/ChatComEquipeGC';
import ListaConversas from '../pages/ListaConversas';
import Chat from '../components/ChatComEquipe/Chat';
import { ChatTypeEnum } from '../components/ChatComEquipe/ChatTypeEnum';
import ConversasPersonal from '../pages/GestaoDeCronicos/ChatComEquipePersonal/ConversasPersonal';
import ConversasPersonalDisable from '../pages/GestaoDeCronicos/ChatComEquipePersonal/ConversaPersonalDisable';
import NovaConversaPersonal from '../pages/GestaoDeCronicos/ChatComEquipePersonal/ConversasPersonal/NovaConversaPersonal';
import ButtonsMenu from '../pages/Home/ButtonsMenu';
import InformePagamentos from '../pages/Login/InformePagamentos';
import Aeromedica from '../pages/MeusBeneficios/Aeromedica';
import OutrasSolicitacoesFinanceiras from '../pages/Financeiro/OutrasSolicitacoesFinanceiras';
import NovaSolicitacao from '../pages/Financeiro/OutrasSolicitacoesFinanceiras/NovaSolicitacao';
import MinhasSolicitacoes from '../pages/Financeiro/OutrasSolicitacoesFinanceiras/MinhasSolicitacoes';
import Acionar2ViaBoleto from '../pages/Acionar2ViaBoleto';
import TranscricaoSolicitacao from '../pages/GuiasEAutorizacoes/TranscricaoSolicitacao';
import NovaTranscricao from '../pages/GuiasEAutorizacoes/TranscricaoSolicitacao/NovaTranscricao';
import ConsultarTranscricao from '../pages/GuiasEAutorizacoes/TranscricaoSolicitacao/Consultar';
import DetalhesTranscricao from '../pages/GuiasEAutorizacoes/TranscricaoSolicitacao/Consultar/Detalhes';
import ResolverPendenciaTranscricao from '../pages/GuiasEAutorizacoes/TranscricaoSolicitacao/Consultar/ResolverPendencia';

const RoutesApp: React.FC = () => {

  const PrivateRoute: React.FC<PrivateRouteProps> = ({ element }) => {
    const [authenticated, setAuthenticated] = useState<boolean | null>(null);

    useEffect(() => {
      checkAuthentication();
    }, [window.location.pathname]);

    const checkAuthentication = async () => {
      const isAuthenticated = await isAuthenticated_();
      setAuthenticated(isAuthenticated);
    };

    const isAuthenticated_ = async (): Promise<boolean> => {
      var auth = await getTokenClientes() ? true : false;
      return auth;
    }

    if (authenticated === null) {
      return <LoadingApp showLoading={true} />;
    }

    return authenticated ? (
      <>{element}</>
    ) : (
      <Navigate to="/login" replace state={{ from: window.location.pathname }} />
    );
  };

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/cadastro" element={<Register />} />
        <Route path="/informePagamentos" element={<InformePagamentos />} />
        <Route path="/acionar2viaboleto" element={<Acionar2ViaBoleto />} />
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="*" element={<PrivateRoute element={<Page content={<ButtonsMenu />} />} />} />
        <Route path="/home" element={<PrivateRoute element=
          {
            <Page content={<Home />} />
          } />
        } />
        <Route path="/notificacoes/:notificationType" element={<PrivateRoute element=
          {
            <Page content={<Notifications />} />
          } />
        } />
        <Route path="/notificacoes/:notificationType/:notificationId" element={<PrivateRoute element=
          {
            <Page content={<Notification />} />
          } />
        } />
        <Route path="/notificacoes/pesquisaDeSatifacao/:notificationId/:idQuestOperador" element={<PrivateRoute element=
          {
            <Page content={<PesquisaSatisfacao />} />
          } />
        } />
        <Route path="/notificacoes/saude_online/:idAgenda/:tipoNotificacao/:idComunic" element={<PrivateRoute element=
          {
            <Page content={< NotificationConfirmarConsulta />} />
          } />
        } />
        <Route path="/notificacoes/saude_online/medicina_preventiva/:idComunic/:idEventoUsr" element={<PrivateRoute element=
          {
            <Page content={< NotificationMedicinaPreventiva />} />
          } />
        } />
        <Route path="/mapaDoSite" element={<PrivateRoute element=
          {
            <Page content={<MapaDoSite />} />
          } />
        } />

        {/* INÝCIO PÝGINAS MEU PLANO */}
        <Route path="/meuPlano/meuCadastro" element={<PrivateRoute element=
          {
            <Page content={<MeuCadastro />} />
          } />
        } />
        <Route path="/meuPlano/informacoesDoPlano/UtilizacaoDosServicos" element={<PrivateRoute element=
          {
            <Page content={<UtilizacaoDosServicos />} />
          } />
        } />
        <Route path="/meuPlano/informacoesDoPlano/ComponenteCadastral" element={<PrivateRoute element=
          {
            <Page content={<ComponenteCadastral />} />
          } />
        } />
        <Route path="/meuPlano/alterarSenha" element={<PrivateRoute element=
          {
            <Page content={<AlterarSenha />} />
          } />
        } />
        <Route path="/meuPlano/cancelamento/historico" element={<PrivateRoute element=
          {
            <Page content={<CancelamentoHistorico />} />
          } />
        } />
        <Route path="/meuPlano/cancelamento/solicitacao" element={<PrivateRoute element=
          {
            <Page content={<SolicitacaoCancelamento />} />
          } />
        } />
        <Route path="/meuPlano/permissoesVisualizacao" element={<PrivateRoute element=
          {
            <Page content={<PermissoesVisualizacao />} />
          } />
        } />
        <Route path="/meuPlano/excluirConta" element={<PrivateRoute element=
          {
            <Page content={<ExcluirConta />} />
          } />
        } />
        <Route path="/meuPlano/ManualUsoPlano" element={<PrivateRoute element=
          {
            <Page content={<ManualUsoPlano />} />
          } />
        } />
        {/* FIM PÝGINAS MEU PLANO */}

        {/* INÝCIO PÝGINAS SAÚDE ONLINE */}
        <Route path="/saudeOnline/agendarConsulta" element={<PrivateRoute element=
          {
            <Page content={<AgendarConsulta />} />
          } />
        } />
        <Route path="/saudeOnline/meusAgendamentos" element={<PrivateRoute element=
          {
            <Page content={<MeusAgendamentos />} />
          } />
        } />
        <Route path="/saudeOnline/cartaoVirtual" element={<PrivateRoute element=
          {
            <Page content={<CartaoVirtual />} />
          } />
        } />
        <Route path="/saudeOnline/teleorientacaoSaude" element={<PrivateRoute element=
          {
            <Page content={<TeleorientacaoSaude />} />
          } />
        } />
        <Route path="/saudeOnline/ingressarNoAtendimento/:idReuniao/:paVirtual?" element={<PrivateRoute element=
          {
            <IngressarNoAtendimento />
          } />
        } />
        <Route path="/saudeOnline/biometriaFacial" element={<PrivateRoute element=
          {
            <Page content={<BiometriaFacial />} />
          } />
        } />
        <Route path="/saudeOnline/paVirtual" element={<PrivateRoute element=
          {
            <Page content={<PAVirtual />} />
          } />
        } />
        <Route path="/saudeOnline/atestadoMedico" element={<PrivateRoute element=
          {
            <Page content={<AtestadoMedicoDigital />} />
          } />
        } />
        <Route path="/saudeOnline/linhaTempo" element={<PrivateRoute element=
          {
            <Page content={<LinhaTempo />} />
          } />
        } />
        <Route path="/saudeOnline/receitaDigital" element={<PrivateRoute element=
          {
            <Page content={<ReceitaDigital />} />
          } />
        } />
        <Route path="/saudeOnline/resultadoExames" element={<PrivateRoute element=
          {
            <Page content={<ResultadoExames />} />
          } />
        } />
        <Route path="/saudeOnline/anexos" element={<PrivateRoute element=
          {
            <Page content={<Anexos />} />
          } />
        } />
        <Route path="/saudeOnline/avaliacoesEspacoPersonal" element={<PrivateRoute element=
          {
            <Page content={<AvaliacaoEspacoPersonal />} />
          } />
        } />
        <Route path="/saudeOnline/faleComPersonal/conversaEquipe/conversasDisable" element={<PrivateRoute element={<Page content={<ConversasPersonalDisable />} />} />} />
        <Route path="/saudeOnline/faleComPersonal/conversaEquipe/conversas" element={<PrivateRoute element={<Page content={<ConversasPersonal />} />} />} />
        <Route path="/saudeOnline/faleComPersonal/conversaEquipe/conversas/nova" element={<PrivateRoute element={<Page content={<NovaConversaPersonal />} />} />} />
        <Route path="/saudeOnline/faleComPersonal/conversaEquipe/conversas/:statusConversa" element={<PrivateRoute element={<Page content={<ListaConversas chatType={ChatTypeEnum.PERSONAL} />} />} />} />
        <Route path="/saudeOnline/faleComPersonal/conversaEquipe/conversas/:idMsgOrigem/chat" element={
          <PrivateRoute element={<Page content={<Chat chatType={ChatTypeEnum.PERSONAL} />} />} />
        } />
        {/* FIM PÝGINAS SAÚDE ONLINE */}

        {/* INÝCIO PÝGINAS FINANCEIRO */}
        <Route path="/financeiro/extratoCoparticipacao" element={<PrivateRoute element=
          {
            <Page content={<ExtratoCoparticipacao />} />
          } />
        } />
        <Route path="/financeiro/segundaViaBoleto" element={<PrivateRoute element=
          {
            <Page content={<SegundaViaBoleto />} />
          } />
        } />
        <Route path="/financeiro/demonstrativoFatura" element={<PrivateRoute element=
          {
            <Page content={<DemonstrativoFatura />} />
          } />
        } />
        <Route path="/financeiro/comprovanteRecebidos" element={<PrivateRoute element=
          {
            <Page content={<ComprovanteRecebidos />} />
          } />
        } />
        <Route path="/financeiro/cartaDebitoAutomatico" element={<PrivateRoute element=
          {
            <Page content={<CartaDebitoAutomatico />} />
          } />
        } />
        <Route path="/financeiro/cadastrarBoleto" element={<PrivateRoute element=
          {
            <Page content={<CadastrarBoleto />} />
          } />
        } />
        <Route path="/financeiro/cadastroEmailNFe" element={<PrivateRoute element=
          {
            <Page content={<CadastroEmailNFe />} />
          } />
        } />
        <Route path="/financeiro/simuladorMensalidadeReajuste" element={<PrivateRoute element=
          {
            <Page content={<SimuladorMensalidadeReajuste />} />
          } />
        } />
        <Route path="/financeiro/reembolso/solicitacaoDeReembolso" element={<PrivateRoute element=
          {
            <Page content={<SolicitacaoDeReembolso />} />
          } />
        } />
        <Route path="/financeiro/reembolso/solicitacaoDeReembolso/:progress" element={<PrivateRoute element=
          {
            <Page content={<SolicitacaoDeReembolso />} />
          } />
        } />
        <Route path="/financeiro/reembolso/valor" element={<PrivateRoute element=
          {
            <Page content={<ValorReembolso />} />
          } />
        } />
        <Route path="/financeiro/reembolso/regras" element={<PrivateRoute element=
          {
            <Page content={<RegrasReembolso />} />
          } />
        } />
        <Route path="/financeiro/reembolso/perguntasFrequentes" element={<PrivateRoute element=
          {
            <Page content={<ReembolsoFAQ />} />
          } />
        } />
        <Route path="/financeiro/reembolso/meusReembolsos" element={<PrivateRoute element=
          {
            <Page content={<MeusReembolsos />} />
          } />
        } />
        <Route path="/financeiro/reembolso/meusReembolsos/:id/:status" element={<PrivateRoute element=
          {
            <Page content={<PedidoReembolsoDetalhe />} />
          } />
        } />
        <Route path="/financeiro/outrasSolicitacoesFinanceiras" element={<PrivateRoute element=
          {
            <Page content={<OutrasSolicitacoesFinanceiras />} />
          } />
        } />
        <Route path="/financeiro/outrasSolicitacoesFinanceiras/novaSolicitacao" element={<PrivateRoute element=
          {
            <Page content={<NovaSolicitacao />} />
          } />
        } />
        <Route path="/financeiro/outrasSolicitacoesFinanceiras/minhasSolicitacoes" element={<PrivateRoute element=
          {
            <Page content={<MinhasSolicitacoes />} />
          } />
        } />
        {/* FIM PÝGINA FINANCEIRO */}

        {/* INICIO PÝGINAS GUIAS E AUTORIZAÇÕES */}
        <Route path="/guiasEautorizacoes/minhasGuiasEmitidas" element={<PrivateRoute element=
          {
            <Page content={<MinhasGuias />} />
          } />
        } />
        <Route path="/guiasEautorizacoes/ativacaoDeGuiaFutura" element={<PrivateRoute element=
          {
            <Page content={<AtivacaoDeGuia />} />
          } />
        } />
        <Route path="/guiasEautorizacoes/revaliacaoDeGuia" element={<PrivateRoute element=
          {
            <Page content={<RevalidacaoDeGuia />} />
          } />
        } />
        <Route path="/guiasEautorizacoes/reanaliseDeNegativa" element={<PrivateRoute element=
          {
            <Page content={<ReanaliseDeNegativa />} />
          } />
        } />
        <Route
          path="/guiasEautorizacoes/transcricaoSolicitacao"
          element={
            <PrivateRoute
              element={
                <Page content={<TranscricaoSolicitacao />} />
              }
            />
          }
        />
        <Route
          path="/guiasEautorizacoes/transcricaoSolicitacao/novaTranscricao"
          element={
            <PrivateRoute
              element={
                <Page content={<NovaTranscricao />} />
              }
            />
          }
        />
        <Route
          path="/guiasEautorizacoes/transcricaoSolicitacao/consultar/:idTranscricao/resolverPendencia"
          element={
            <PrivateRoute
              element={
                <Page content={<ResolverPendenciaTranscricao />} />
              }
            />
          }
        />
        <Route
          path="/guiasEautorizacoes/transcricaoSolicitacao/consultar/:idTranscricao"
          element={
            <PrivateRoute
              element={
                <Page content={<DetalhesTranscricao />} />
              }
            />
          }
        />
        <Route
          path="/guiasEautorizacoes/transcricaoSolicitacao/consultar"
          element={
            <PrivateRoute
              element={
                <Page content={<ConsultarTranscricao />} />
              }
            />
          }
        />

        {/* FIM PÝGINAS GUIAS E AUTORIZAÇÕES  */}

        {/* INICIO PÝGINAS MEUS BENEFICIOS */}
        <Route path="/meusBeneficios/descontoEmFarmacia" element={<PrivateRoute element=
          {
            <Page content={<DescontoEmFarmacia />} />
          } />
        } />
        <Route path="/meusBeneficios/seguroViagemInternacional" element={<PrivateRoute element=
          {
            <Page content={<SeguroViagemInternacional />} />
          } />
        } />
         <Route path="/meusBeneficios/aeromedica" element={<PrivateRoute element=
          {
            <Page content={<Aeromedica/>} />
          } />
        } />
        {/* INICIO PÝGINAS MEUS BENEFICOS */}
        {/* FIM PÝGINA GUIAS E AUTORIZAÇÕES  */}
        {/* INÝCIO PÝGINAS INFORMAÇÕES CONTRATUAIS */}
        <Route path="/informacoesContratuais/declaracaoPermanencia" element={<PrivateRoute element=
          {
            <Page content={<DeclaracaoPermanencia />} />
          } />
        } />
        <Route path="/informacoesContratuais/consultarCoberturas" element={<PrivateRoute element=
          {
            <Page content={<ConsultarCoberturas />} />
          } />
        } />
        <Route path="/informacoesContratuais/classificacaoProcedimentos" element={<PrivateRoute element=
          {
            <Page content={<ClassificacaoProcedimentos />} />
          } />
        } />
        {/* FIM PÝGINAS INFORMACOES CONTRATUAIS  */}

        {/* INICIO GUIA MÉDICO */}
        <Route path="/guiaMedico" element={<PrivateRoute element=
          {
            <Page content={<GuiaMedico />} />
          } />
        } />
        {/* FIM GUIA MÉDICO */}
        <Route path="/faleComUnimed" element={<PrivateRoute element=
          {
            <Page content={<FaleComUnimed />} />
          } />
        } />

        <Route path="/guiaMedico/:nomeServico" element={<PrivateRoute element=
          {
            <Page content={<GuiaMedicoBusca />} />
          } />
        } />

        {/* INICIO SAÚDE E BEM-ESTAR */}

        <Route path="/saudeBemEstar/unimedAcolhe" element={<PrivateRoute element={<Page content={<UnimedAcolhe />} />} />} />
        <Route path="/saudeBemEstar/unimedAcolhe/inicio" element={<PrivateRoute element={<Page content={<UnimedAcolhe />} />} />} />
        <Route path="/saudeBemEstar/unimedAcolhe/manualDeAtendimento" element={<PrivateRoute element={<Page content={<ManualUnimedAcolhe />} />} />} />
        <Route path="/saudeBemEstar/unimedAcolhe/boasVindas/oqueEUnimedAcolhe" element={<PrivateRoute element={<Page content={<OQueEUnimedAcolhe />} />} />} />
        <Route path="/saudeBemEstar/unimedAcolhe/oqueEUnimedAcolhe" element={<PrivateRoute element={<Page content={<OQueEUnimedAcolhe />} />} />} />
        <Route path="/saudeBemEstar/unimedAcolhe/meuPsicoterapeuta" element={<PrivateRoute element={<Page content={<MeuPsicoterapeuta />} />} />} />
        <Route path="/saudeBemEstar/unimedAcolhe/meuPsicoterapeuta/solicitarTroca" element={<PrivateRoute element={<Page content={<SolicitarTrocaPsicoterapeuta />} />} />} />
        <Route path="/saudeBemEstar/gestaoDeCronicos/captacao/:step/:idComunic" element={<PrivateRoute element={<Page content={<Captacao />} />} />} />
        <Route path="/saudeBemEstar/conteudos" element={<PrivateRoute element={<Page content={<Conteudos />} />} />} />
        <Route path="/saudeBemEstar/conteudos/:id" element={<PrivateRoute element={<Page content={<Conteudo />} />} />} />
        <Route path="/saudeBemEstar/palestrasEventos/confirmados" element={<PrivateRoute element={<Page content={<PalestrasEventosConfirmados />} />} />} />
        <Route path="/saudeBemEstar/palestrasEventos/convites" element={<PrivateRoute element={<Page content={<PalestrasEventosConvites />} />} />} />

        { /* INÝCIO AUTO-AVALIAÇÃO */}
        <Route path="/saudeBemEstar/unimedAcolhe/autoAvaliacao" element={<PrivateRoute element={<Page content={<AutoAvaliacao />} />} />} />
        <Route path="/saudeBemEstar/unimedAcolhe/autoAvaliacao/:refazer" element={<PrivateRoute element={<Page content={<AutoAvaliacao />} />} />} />
        <Route path="/saudeBemEstar/unimedAcolhe/autoAvaliacao/info" element={<PrivateRoute element={<Page content={<AutoavaliacaoInfo />} />} />} />
        <Route path="/saudeBemEstar/unimedAcolhe/autoAvaliacao/questoes/:idRespQuestBenef" element={<PrivateRoute element={<Page content={<AutoAvaliacaoQuestoes />} />} />} />
        <Route path="/saudeBemEstar/unimedAcolhe/autoAvaliacao/questoes" element={<PrivateRoute element={<Page content={<AutoAvaliacaoQuestoes />} />} />} />
        <Route path="/saudeBemEstar/unimedAcolhe/autoAvaliacao/resultado/:idQuestOrResultType" element={<PrivateRoute element={<Page content={<AutoAvaliacaoResult />} />} />} />
        { /* FIM AUTO-AVALIAÇÃO */}

        { /* INÝCIO MEU DIARIO */}
        <Route path="/saudeBemEstar/unimedAcolhe/meuDiario/:step" element={<PrivateRoute element={<Page content={<MeuDiario />} />} />} />
        <Route path="/saudeBemEstar/unimedAcolhe/meuDiario/registro/:id" element={<PrivateRoute element={<Page content={<DiaryRegister />} />} />} />
        { /* FIM MEU DIARIO  */}
        { /* INÝCIO AUTO-AVALIAÇÃO */}
        <Route path="/saudeBemEstar/unimedAcolhe/agendamentos" element={<PrivateRoute element={<Page content={<Agendamentos />} />} />} />
        <Route path="/saudeBemEstar/unimedAcolhe/agendamentos/detalhes" element={<PrivateRoute element={<Page content={<AgendamentosMaisDetalhes />} />} />} />
        <Route path="/saudeBemEstar/unimedAcolhe/agendamentos/agendar" element={<PrivateRoute element={<Page content={<Agendar />} />} />} />
        <Route path="/saudeBemEstar/unimedAcolhe/agendamentos/lista" element={<PrivateRoute element={<Page content={<MeusAgendamentosPsico />} />} />} />
        { /* FIM AUTO-AVALIAÇÃO */}

        {/* FIM SAÚDE E BEM-ESTAR */}


        { /* INÝCIO GESTAO DE CRONICOS */}
        <Route path="/saudeBemEstar/gestaoDeCronicos" element={<PrivateRoute element={<Page content={<HomeGC />} />} />} />
        <Route path="/saudeBemEstar/gestaoDeCronicos/conhecaOPrograma" element={<PrivateRoute element={<Page content={<ConhecaOPrograma />} />} />} />
        <Route path="/saudeBemEstar/gestaoDeCronicos/manualDoUsuario" element={<PrivateRoute element={<Page content={<ManualDoUsuarioCronicos />} />} />} />
        <Route path="/saudeBemEstar/gestaoDeCronicos/meusAgendamentos" element={<PrivateRoute element={<Page content={<AgendamentosGC />} />} />} />
        <Route path="/saudeBemEstar/gestaoDeCronicos/conversaEquipe" element={<PrivateRoute element={<Page content={<ChatComEquipeGC />} />} />} />
        <Route path="/saudeBemEstar/gestaoDeCronicos/agendar" element={<PrivateRoute element={<Page content={<AgendarGC />} />} />} />
        <Route path="/saudeBemEstar/gestaoDeCronicos/conversaEquipe/conversas" element={<PrivateRoute element={<Page content={<Conversas />} />} />} />
        <Route path="/saudeBemEstar/gestaoDeCronicos/conversaEquipe/conversas/nova" element={<PrivateRoute element={<Page content={<NovaConversa />} />} />} />
        <Route path="/saudeBemEstar/gestaoDeCronicos/conversaEquipe/conversas/:statusConversa" element={<PrivateRoute element={<Page content={<ListaConversas chatType={ChatTypeEnum.GC} />} />} />} />
        <Route path="/saudeBemEstar/gestaoDeCronicos/conversaEquipe/conversas/:idMsgOrigem/chat" element={
          <PrivateRoute element={<Page content={<Chat chatType={ChatTypeEnum.GC} />} />} />
        } />
        <Route path="/saudeBemEstar/gestaoDeCronicos/primeiroAgendamento/:idComunic" element={<PrivateRoute element={<Page content={<PrimeiroAgendamentoWrapper />} />} />} />
        <Route path="/saudeBemEstar/gestaoDeCronicos/palestrasEventos" element={<PrivateRoute element={<Page content={<PalestrasEventos />} />} />} />
        <Route path="/saudeBemEstar/gestaoDeCronicos/palestrasEventos/confirmados" element={<PrivateRoute element={<Page content={<PalestrasEventosConfirmados />} />} />} />
        <Route path="/saudeBemEstar/gestaoDeCronicos/palestrasEventos/convites" element={<PrivateRoute element={<Page content={<PalestrasEventosConvites />} />} />} />
        <Route path="/saudeBemEstar/gestaoDeCronicos/conteudos" element={
          <PrivateRoute element={<Page content={<Conteudos />} />} />
        } />
        <Route path="/saudeBemEstar/gestaoDeCronicos/conteudos/:id" element={
          <PrivateRoute element={<Page content={<Conteudo />} />} />
        } />
        <Route path="/saudeBemEstar/gestaoDeCronicos/encerramento/:idComunic" element={<PrivateRoute element={<Page content={<Encerramento />} />} />} />

        { /* FIM GESTAO DE CRONICOS  */}

        {/* FIM SAÚDE E BEM-ESTAR */}
      </Routes>
    </Router>
  );
};

export default RoutesApp;